import { EmbeddedCheckoutStrategy } from "@/contracts/EmbeddedCheckoutStrategy";
import EmbeddedCheckout, { EmbeddedCheckoutEvents } from "@/types/EmbeddedCheckout";

export default class IngresseEmbeddedCheckout implements EmbeddedCheckoutStrategy {
  destroy(): Promise<void> {
    throw new Error("Method not implemented.");
  }

  mount(identifier: string, session: EmbeddedCheckout, listeners: EmbeddedCheckoutEvents): Promise<void> {
    window.IngresseCheckout.mount(identifier, session.url, {
      locale: "pt-BR",
      onSuccess: listeners.onSuccess,
      onTimeout: listeners.onTimeout,
      onCheckoutLoaded: () => {
        console.log("[Ingresse] - Checkout loaded");
      },
      style: {
        colorBrand: "EA8300",
        colorBg: "FFFFFF",
      },
    });

    return Promise.resolve();
  }
}
